export default "<app-faq-banner [title]=\"bannerTitle\"></app-faq-banner>\r\n<app-faq-viewer [faq]=\"faq\" [loading]=\"loading\"></app-faq-viewer>\r\n"